import React, { useState } from "react";
import axios from "axios";

function ContactForm() {
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [mensaje, setMensaje] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/contacto`, {
        nombre,
        email,
        mensaje,
      });
      alert("Mensaje enviado correctamente");
      setNombre("");
      setEmail("");
      setMensaje("");
    } catch (error) {
      console.error(error);
      alert("Error al enviar el mensaje");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <h2>Contáctanos</h2>
      <div>
        <label>Nombre:</label>
        <input
          type="text"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Mensaje:</label>
        <textarea
          value={mensaje}
          onChange={(e) => setMensaje(e.target.value)}
          required
        />
      </div>
      <button type="submit">Enviar</button>
    </form>
  );
}

export default ContactForm;